import { HttpClient, HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { initPaginate } from '../interfaces/misc.interface';


@Injectable({
    providedIn: 'root',
})
export class PaymentService {

    private baseUrl = environment.baseUrl;
    private publicUrl = environment.baseUrl + 'public/';

    constructor(private http: HttpClient) { }

    private handleError(error: HttpErrorResponse) {
        return throwError(() => new Error(error.message || 'Server error'));
    }

    getReference(reference: string): Observable<any> {
        const url = `${this.publicUrl}payment/status/reference`;
        const params = new HttpParams()
            .set('reference', reference)
        return this.http
            .get<any>(url, { params })
            .pipe(catchError(this.handleError));
    }


    generateMerchantReference(request: any): Observable<any> {
        const url = `${this.publicUrl}payment/generate-merchant-reference`;

        return this.http
            .post<any>(url, request)
            .pipe(
                catchError(this.handleError));
    }

    prepareZimswitchCheckout(request: any): Observable<any> {
        const url = `${this.publicUrl}payment/create-check-out`;

        return this.http
            .post<any>(url, request)
            .pipe(catchError(this.handleError));
    }

    authenticateValidate(merchantReference: string): Observable<any> {
        const url = `${this.publicUrl}payment/authenticate`;
        return this.http
            .post<any>(url, { merchantReference })
            .pipe(catchError(this.handleError));
    }

    getPublicActiveFeeTypes(): Observable<any> {
        const url = this.publicUrl + 'fee/list-active';

        return this.http
            .get<any>(url);
    }

    getCurrencies(
        name = '',
        status = 'ACTIVE'
    ): Observable<any> {
        const params = new HttpParams()
            .set('pageSize', 100)
            .set('pageNumber', 1)
            .set('name', name)
            .set('status', status);

        return this.http.get<any[]>(this.baseUrl + 'public/currency', { params });
    }

    getApplicationId(): Observable<any> {
        return this.http.get(this.baseUrl + 'public/payment/cbz/application-id', { responseType: 'text' });
    }

    getPaymentHistoryByUser(
        userId: string,
        pagination = initPaginate()
    ): Observable<any> {
        const params = new HttpParams()
            .set('pageNumber', `${pagination.pageNumber}`)
            .set('pageSize', `${pagination.pageSize}`)
            .set('userId', userId);

        return this.http.get<any[]>(this.baseUrl + 'payment/', { params });
    }

    getAllPaymentHistory(
        pagination = initPaginate()
    ): Observable<any> {
        const params = new HttpParams()
            .set('pageNumber', `${pagination.pageNumber}`)
            .set('pageSize', `${pagination.pageSize}`)

        return this.http.get<any[]>(this.baseUrl + 'payment/all', { params });
    }

    searchByInvoiceNumber(
        invoiceNumber: string
    ): Observable<any> {
        const params = new HttpParams()
            .set('reference', invoiceNumber)

        return this.http.get<any[]>(this.baseUrl + 'public/payment/reference', { params });
    }

    getFeeByServiceCode(serviceCode: string): Observable<any> {
        return this.http.get<any[]>(this.baseUrl + 'fee/service/' + serviceCode);
    }

    //Fees
    getFees(pageNumber: number, pageSize: number, state = 'ACTIVE') {
        const url = `${this.baseUrl}fee/`;
        const params = new HttpParams()
        .set('pageNumber', pageNumber)
        .set('pageSize', pageSize)
        .set('state', state);
        return this.http.get<any>(url, { params });
    }

    getFeeById(feeId: string) {
        const url = `${this.publicUrl}fee/${feeId}`;
        return this.http.get<any>(url);
    }

    getFeeByType(feeType: string) {
        const url = `${this.baseUrl}fee/by-type/${feeType}`;
        return this.http.get<any>(url);
    }

    updateFee(feeId: string, payload: any) {
        const url = `${this.baseUrl}fee/${feeId}`;
        return this.http.put<any>(url, payload);
    }

}
